import React from 'react'

export default function UserConfigurationScreen() {
  return (
    <div className=' container' style={{margin:"40px"}}>
<h5>UserConfigurationScreen <span> <i className='bi bi-people '></i> </span>   
</h5>
<div className=" d-flex  flex-column">
<span><input type="checkbox" id="Remmber" style={{margin:"10px"}}/>Medical Validation </span>
<span><input type="checkbox" id="Remmber"  style={{margin:"10px"}}/>Benfits Validation</span>
<span><input type="checkbox" id="Remmber"  style={{margin:"10px"}}/>Coding Validation </span>
<span><input type="checkbox" id="Remmber"  style={{margin:"10px"}}/>Historal Validation </span>
<span><input type="checkbox" id="Remmber"  style={{margin:"10px"}}/>Frequency Validation </span>
<span><input type="checkbox" id="Remmber"  style={{margin:"10px"}}/>Machine Learning  </span>
<span><input type="checkbox" id="Remmber"  style={{margin:"10px"}}/>Drug Validation</span>
<span><input type="checkbox" id="Remmber"  style={{margin:"10px"}}/>Other Validation </span>




</div>


    </div>
  )
}
